import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IElementBaseModel } from '../../Interface/base/element-base-model.interface';
import { IGroupModel } from '../../Interface/group-model.interface';

/**
 *  遍历 入参 uiModel 的 所在的 group
 * @param uiModel
 * @param iterationFunc  param: groupModel,  returan: stop
 */
export function enumerateSimilarGroup(uiModel, iterationFunc) {
    let stop = false;
    while (uiModel.parent && stop !== true) {
        uiModel = uiModel.parent;
        if (uiModel.type === UIModelType.GROUP || uiModel.type === UIModelType.SMART_ART) {
            stop = iterationFunc(uiModel);
        }
    }
}


/**
 *  遍历 入参 uiModel 的 所在的 group
 * @param uiModel
 * @param iterationFunc  param: groupModel,  returan: stop
 */
export function enumerateGroup(uiModel, iterationFunc) {
    let stop = false;
    while (uiModel.parent && stop !== true) {
        uiModel = uiModel.parent;
        if (uiModel.type === UIModelType.GROUP) {
            stop = iterationFunc(uiModel);
        }
    }
}

/**
 * dfs深度搜索遍历group的所有子元素
 * @param groupModel
 * @param iterationFunc
 * @param {any} exceptTypes
 */
export function enumerateGroupItems(
    groupModel: IGroupModel, iterationFunc,
    exceptTypes: string[] | null = null,
) {
    if (groupModel && groupModel.type === UIModelType.GROUP) {
        const childLength = groupModel.children.length;
        for (let i = 0; i < childLength; i++) {
            const child = groupModel.children[i];
            if (!(child?.type
                && exceptTypes
                && Array.isArray(exceptTypes)
                && (exceptTypes as string[]).includes(child.type))) {
                iterationFunc(child);
            }
            if (child?.type === UIModelType.GROUP) {
                enumerateGroupItems(child as IGroupModel, iterationFunc, exceptTypes);
            }
        }
    }
}

export function groupChildrenSortedByRootGroup(groupChildren: IElementBaseModel[], callback) {
    const groupChildrenMatrix: IElementBaseModel[][] = [];
    const rootGroupArray = [];
    const rootGroupMap = {};
    let arrayCount = 0;
    if (groupChildren && groupChildren.length > 0) {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < groupChildren.length; i++) {
            if (groupChildren[i].parent?.type === UIModelType.GROUP) {
                let rootGroup: IGroupModel | null = null;
                enumerateGroup(groupChildren[i], (group: IGroupModel) => {
                    rootGroup = group;
                });
                if (rootGroup) {
                    const { key } = rootGroup as IGroupModel;
                    if (rootGroupMap[key]) {
                        const index = rootGroupMap[key] - 1;
                        groupChildrenMatrix[index].push(groupChildren[i]);
                    } else {
                        const currentArray = [groupChildren[i]];
                        groupChildrenMatrix.push(currentArray);
                        arrayCount += 1;
                        rootGroupMap[key] = arrayCount;
                        rootGroupArray[arrayCount - 1] = rootGroup;
                    }
                }
            }
        }
    }
    if (callback) {
        callback(rootGroupArray, groupChildrenMatrix);
    }
}

/**
* 获取子元素数组中，每条分支上深度最大的节点
* @param childModels 变更的子元素数组
 * @returns 节点数组
*/
export function getMaxDepthChildrenInGroup(childModels: IElementBaseModel[]): IElementBaseModel[] {
    if (childModels.length <= 1) return childModels;
    const visitedModel = new Set<IElementBaseModel>();
    const maxDepthChildren = new Set(childModels);
    childModels.forEach((model) => {
        visitedModel.add(model);
        enumerateGroup(model, (groupModel: IGroupModel) => {
            groupModel.children.forEach((child) => {
                if (!visitedModel.has(child)) {
                    visitedModel.add(child);
                    maxDepthChildren.delete(child);
                }
            });
        });
    });
    return Array.from(maxDepthChildren);
}
